export function compareSemver(a: string, b: string): number {
  const pa = a.split('.').map(Number);
  const pb = b.split('.').map(Number);

  for (let i = 0; i < 3; i++) {
    const versionA = pa[i] || 0;
    const versionB = pb[i] || 0;

    if (versionA > versionB) return 1;
    if (versionA < versionB) return -1;
  }

  return 0;
}

export function isVersionNewer(current: string, stored: string): boolean {
  return compareSemver(current, stored) > 0;
}
